var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItalicsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 14,
    viewBox: "0 0 6 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.76006 4H4.76006L2.56006 14H0.560059L2.76006 4ZM4.44006 0C4.24228 0 4.04894 0.0586491 3.88449 0.16853C3.72004 0.278412 3.59187 0.434591 3.51618 0.617317C3.44049 0.800043 3.42069 1.00111 3.45927 1.19509C3.49786 1.38907 3.5931 1.56725 3.73295 1.70711C3.8728 1.84696 4.05099 1.9422 4.24497 1.98079C4.43895 2.01937 4.64002 1.99957 4.82274 1.92388C5.00547 1.84819 5.16165 1.72002 5.27153 1.55557C5.38141 1.39112 5.44006 1.19778 5.44006 1C5.44006 0.734784 5.3347 0.48043 5.14717 0.292893C4.95963 0.105357 4.70527 0 4.44006 0Z",
    fill: "#393A4A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalicsIcon);
export default __webpack_public_path__ + "static/media/ItalicsIcon.30665c6146ff02b1031504bb2b6da83d.svg";
export { ForwardRef as ReactComponent };